<template>
  <h1>Info / FAQs</h1>
</template>
<script>
export default {
  name: "InfoWidget",
  data() {
    return {};
  }
};
</script>
